/**
 *
 * FBMobileSectionHeader
 *
 */

import React, { useMemo } from 'react';
import classNames from 'classnames';

// styles
import './style.scss';

// layout components
import ErrorBoundary from 'engine/ErrorBoundary';

import { getCommunicationTypeLabel } from 'utils/helpers/helper.generateData';

function FBMobileSectionHeader({
  types,
  visibility,
  // default props
  className
}) {
  const render = useMemo(() => (
    <div className={classNames(
      'tcf-fb-mobile-section-header',
      types?.map(el => el),
      className
    )}>
      <div className="header-wrapper">
        {types?.map(type => (
          <div className={`header-tag header-tag--${type}`}>{getCommunicationTypeLabel(type)?.label}</div>
        ))}
      </div>
    </div>
  ), [types, className]);

  return (
    <ErrorBoundary>
      {!!visibility && render}
    </ErrorBoundary>
  );
}

FBMobileSectionHeader.defaultProps = {
  types: ['documents'],
  visibility: true
};
export default FBMobileSectionHeader;
